import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { by } from '../../../utils'
import mapStateToAvailabilityProps from '../../../reducers/availability/mappers'

import * as Styled from './TiledSizePickerTile.styles'

export class TiledSizePickerTile extends Component {
  render() {
    const { isAvailable, type, selectPartNumber, partNumber, attributes, rootPartNumber } = this.props

    const { shortValue, value } = attributes.find(by.typeOf(type))

    const active = partNumber === rootPartNumber
    const disabled = !isAvailable || !partNumber
    const onClick = selectPartNumber(partNumber)

    return (
      <Styled.Button
        type='button'
        data-partnumber={partNumber}
        data-active={active}
        data-type={type}
        data-value={value}
        data-test='tiled-size-picker-tile-button'
        {...{ disabled, onClick, active }}
      >
        {shortValue}
      </Styled.Button>
    )
  }
}

TiledSizePickerTile.propTypes = {
  partNumber: PropTypes.string.isRequired
}

export default connect(mapStateToAvailabilityProps)(TiledSizePickerTile)
